export default __webpack_public_path__ + "static/media/icr_armado.d5e038a9.svg";